export default __webpack_public_path__ + "static/asset-sheet-7bd00662af31a546659eba8d07b29ebe.svg";